import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { filter, map } from 'rxjs/operators';
import {
    AppointmentListService
} from '../appointment-list/state/appointment-list.service';

@Component({
    selector: 'appointment-log-event-log',
    templateUrl: './appointment-log-event-log.component.html'
})

export class AppointmentLogEventLogComponent implements OnInit {
    hideEventsBeforeAppointment = true;
    eventsLog$: Observable<Array<any>>;
    viewModel$: Observable<Array<any>>;
    logEventLoading: boolean;
    selectedType = 'text';
    selectedEvent: any;

    @Output() readonly selectedEventLog: EventEmitter<any> = new EventEmitter<any>();
    @Output() readonly selectedXmlIdList: EventEmitter<any> = new EventEmitter<any>();
    @Input() appointmentId: any;
    @Input() selectedAppointment: any;
    @Input() selectedAppointmentDetail: any;
    @Input() selectedTimeZone;

    showXmlLog(xmlIdList): void {
        this.selectedXmlIdList.emit(xmlIdList);
    }

    ngOnInit(): void {
        this.logEventLoading = true;
        this.eventsLog$ = this.appointmentListService.getLogEvent(this.appointmentId);
        this.viewModel$ = this.eventsLog$.pipe(
            filter(logs => logs !== undefined),
            map(logs => {
                this.logEventLoading = false;
                let displayLogs = [];
                // the description should only display message part (every thing else should be part of RAW)
                logs.forEach(log => {
                    const extractDescAndAppointmentChanges = this.extractAndConvertMessage(log.description);
                    log.appointment = extractDescAndAppointmentChanges['extractdAppointmentChanges'];
                    displayLogs.push(
                        {'raw': log,
                        'text': {'description': extractDescAndAppointmentChanges['extractdDescription'],
                                    timestamp: log.timestamp,
                                    entityType: log. entityType,
                                    eventId: log.eventId,
                                    appointment: log.appointment
                                    }
                        });
                });

                return displayLogs;
            })
        );
    }

    extractAndConvertMessage(description) : any {
        let extractDescAndAppointmentChanges = {};
        let extractdDescription = '';
        let extractdAppointmentChanges;
        try {
            const descriptionJson = JSON.parse(description);
            extractdDescription = '';
            extractdAppointmentChanges = this.extractAppointmentEvent(descriptionJson);
            extractdDescription = descriptionJson['message'];
            const matches = extractdDescription.match(/\$[a-zA-Z.]+/g);
            // console.log(matches);
            let i = 0;
            if (matches !== null) {
                while (i !== matches.length) {
                    let key = matches[i].replace('$', '');
                    //handling if full stop is included
                    key = key.endsWith('.') ? key.substr(0, key.length -1) : key;
                    let replaceWith = '';
                    if (key.indexOf('.') === -1) {
                        replaceWith = descriptionJson[key];
                    } else {
                        const beforeAfter = key.split('.');
                        const beforeAfterJson = descriptionJson[beforeAfter[0]];
                        replaceWith = beforeAfterJson[beforeAfter[1]];
                    }
                    extractdDescription = extractdDescription.replace(matches[i], replaceWith);
                    // console.log(extractdDescription);
                    i++;
                }
                extractDescAndAppointmentChanges['extractdDescription'] = extractdDescription;
                extractDescAndAppointmentChanges['extractdAppointmentChanges'] = extractdAppointmentChanges;
            }
        } catch (e) {
            console.log(e);
            extractdDescription = description;
            extractdAppointmentChanges = description;
        }
        extractDescAndAppointmentChanges['extractdDescription'] = extractdDescription;
        extractDescAndAppointmentChanges['extractdAppointmentChanges'] = extractdAppointmentChanges;

        return extractDescAndAppointmentChanges;
    }

    extractAppointmentEvent(descriptionJson): any {
        let extractdAppointmentChanges = { after: '', before: '' };
        Object.entries(descriptionJson).map(([key, value]) => {
            if (key !== 'message' &&  key !== 'messageId' && key !== 'stringId') {
                extractdAppointmentChanges[key] = value;
            }
        });

        return extractdAppointmentChanges;
    }

    onRowSelect(event): any {
        this.selectedEvent = event.data;
    }
    onRowUnselect(event): any {
        this.selectedEvent = undefined;
    }

    constructor(private appointmentListService: AppointmentListService) {
    }
}
